import React, { Fragment } from 'react';
import _ from 'lodash';

export function line_items_form_layout(lineItem, taxRate) {

	const subTotal = lineItem?.count * lineItem?.price;
	const taxAmount = lineItem?.taxable ? subTotal * (taxRate / 100 || 0) : 0;
	const lineTotal = subTotal + taxAmount;

	return (
		[{
			column_class: 'col-lg-12',
			body: [{
				section:
					<Fragment>
						<h3 className="m-t-none m-b">{ lineItem?.name }</h3>
					</Fragment>,
				layout: [{
					autoSelect: true,
					grid: 'col-5',
					label: 'Quantity',
					field: 'count',
					type: 'number',
				}, {
					autoSelect: true,
					grid: 'col-7',
					label: 'Price',
					field: 'price',
					type: 'usd',
				}, {
					grid: 'col-5 mb-n1',
					label: 'Taxable',
					field: 'taxable',
					type: 'checkbox',
				}, {
					grid: 'col-3 text-right mt-3',
					text: 'Sub Total:',
					type: 'plaintext',
				}, {
					grid: 'col-4 text-right pr-3 mt-3',
					text: `$ ${subTotal.toFixed(2)}`,
					type: 'plaintext',
				}, {
					grid: 'col-8 text-right',
					text: `${taxRate}% Tax:`,
					type: 'plaintext',
				}, {
					grid: 'col-4 text-right pr-3',
					text: `$ ${taxAmount.toFixed(2)}`,
					type: 'plaintext',
				}, {
					grid: 'col-8 text-right',
					text: 'Line Total:',
					type: 'plaintext',
				}, {
					grid: 'col-4 text-right pr-3',
					text: `$ ${lineTotal.toFixed(2)}`,
					type: 'plaintext',
				}, {
					fitContent: true,
					grid: 'col-12',
					label: 'Description',
					field: 'description',
					type: 'textarea',
				}],
			}],
		}]
	);
};